import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { PrecioClienteState, SaveBulkRequest } from '../types';
import { PrecioClienteService } from '../services/precioClienteService';

interface PrecioClienteActions {
  fetchByCliente: (idCliente: number) => Promise<void>;
  fetchByClienteAndTipo: (idCliente: number, tipoProceso: string) => Promise<void>;
  saveBulk: (request: SaveBulkRequest) => Promise<boolean>;
  deletePrecio: (id: number) => Promise<boolean>;
  clearError: () => void;
  reset: () => void;
}

type PrecioClienteStore = PrecioClienteState & PrecioClienteActions;

const initialState: PrecioClienteState = {
  precios: [],
  loading: false,
  error: null,
};

export const usePrecioClienteStore = create<PrecioClienteStore>()(
  devtools(
    (set) => ({
      ...initialState,

      fetchByCliente: async (idCliente: number) => {
        set({ loading: true, error: null });
        try {
          const precios = await PrecioClienteService.getByCliente(idCliente);
          set({ precios, loading: false });
        } catch (error) {
          set({
            error: error instanceof Error ? error.message : 'Error al cargar precios',
            loading: false,
          });
        }
      },

      fetchByClienteAndTipo: async (idCliente: number, tipoProceso: string) => {
        set({ loading: true, error: null });
        try {
          const precios = await PrecioClienteService.getByClienteAndTipo(
            idCliente, tipoProceso
          );
          set({ precios, loading: false });
        } catch (error) {
          set({
            error: error instanceof Error ? error.message : 'Error al cargar precios',
            loading: false,
          });
        }
      },

      saveBulk: async (request: SaveBulkRequest) => {
        set({ loading: true, error: null });
        try {
          await PrecioClienteService.saveBulk(request);
          set({ loading: false });
          return true;
        } catch (error) {
          set({
            error: error instanceof Error ? error.message : 'Error al guardar precios',
            loading: false,
          });
          return false;
        }
      },

      deletePrecio: async (id: number) => {
        set({ loading: true, error: null });
        try {
          await PrecioClienteService.delete(id);
          set({ loading: false });
          return true;
        } catch (error) {
          set({
            error: error instanceof Error ? error.message : 'Error al eliminar precio',
            loading: false,
          });
          return false;
        }
      },

      clearError: () => set({ error: null }),
      reset: () => set(initialState),
    }),
    { name: 'precio-cliente-store' }
  )
);
